module.exports = __webpack_public_path__ + "static/img/KE.e1f7a1f1.svg";